<template>
  <v-app class="background">
    <v-app-bar app color="primary">
      <v-toolbar-title class="ml-8 white--text">
        <v-btn to="/" color="primary">Demo</v-btn>
        | just-feedback
      </v-toolbar-title>

      <v-spacer />

      <v-menu open-on-hover offset-y v-if="isAdmin">
        <template v-slot:activator="{ on }">
          <v-btn icon color="primary" dark v-on="on">
            <v-icon color="white">{{ icons.mdiPuzzlePlus }}</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item href="/module/layout">
            <v-list-item-title>Layout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu open-on-hover offset-y v-if="isAdmin">
        <template v-slot:activator="{ on }">
          <v-btn icon color="primary" dark v-on="on">
            <v-icon color="white">{{ icons.mdiPuzzleEdit }}</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item href="/module/layout">
            <v-list-item-title>Layout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu open-on-hover offset-y v-if="isAuthenticated">
        <template v-slot:activator="{ on }">
          <v-btn icon color="primary" dark v-on="on">
            <v-icon color="white">{{ icons.mdiPuzzle }}</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item href="/module/layout">
            <v-list-item-title>Layout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu open-on-hover offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon title="coming soon" v-on="on">
            <v-icon color="white">{{ icons.mdiAccount }}</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-on:click="login" v-if="!isAuthenticated">
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout" v-if="isAuthenticated">
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
          <v-list-item v-on:click="setAdmin" v-if="!isAdmin && isAuthenticated">
            <v-list-item-title>Admin-Mode</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setNotAdmin" v-if="isAdmin">
            <v-list-item-title>No-Admin-Mode</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

    <v-footer padless color="secondary">
      <v-container v-if="!footerExtended" class="text-center white--text">
        &copy;{{ new Date().getFullYear() }} | just-feedback
        <v-btn icon @click="toggleFooter">
          <v-icon color="white">{{ icons.mdiDotsHorizontal }}</v-icon>
        </v-btn>
      </v-container>
      <v-card padless width="100%" v-if="footerExtended" color="secondary">
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn icon @click="toggleFooter">
            <v-icon color="white">{{ icons.mdiCloseThick }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider />

        <v-card-text class="white--text text-center">
          &copy;{{ new Date().getFullYear() }} —
          <v-chip color="secondary" href="https://www.just-feedback.com"
            >just feedback</v-chip
          >
        </v-card-text>

        <v-divider />
        <v-card-text class="white--text text-center">
          <v-btn
            href="datenschutzerklaerung.html"
            target="_blank"
            color="secondary"
            >Datenschutzerklärung</v-btn
          >
          <v-btn href="impressum.html" target="_blank" color="secondary"
            >Impressum</v-btn
          >
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<style lang="scss"></style>

<script>
import {
  mdiAccount,
  mdiTools,
  mdiPuzzle,
  mdiPuzzleStar,
  mdiPuzzlePlus,
  mdiPuzzleEdit,
  mdiDotsHorizontal,
  mdiCloseThick
} from "@mdi/js";

export default {
  name: "App",

  data: () => ({
    icons: {
      mdiTools,
      mdiAccount,
      mdiPuzzle,
      mdiPuzzleStar,
      mdiPuzzlePlus,
      mdiPuzzleEdit,
      mdiDotsHorizontal,
      mdiCloseThick
    },
    isAuthenticated: false,
    isAdmin: false,
    footerExtended: false
  }),
  methods: {
    login: function() {
      this.isAuthenticated = true;
    },
    logout: function() {
      this.isAuthenticated = false;
    },
    setAdmin: function() {
      this.isAdmin = true;
    },
    setNotAdmin: function() {
      this.isAdmin = false;
    },
    toggleFooter: function() {
      this.footerExtended = !this.footerExtended;
    }
  }
};
</script>
